export default (result) => {
	let datas = [] // 点数据
	let lines = [] // 线数据
	// {
	// 	"id": "0",
	// 	"name": "刘一",
	// 	"symbolSize": 20,
	// 	"value": 28.685715,
	// 	"category": 0
	// }
	// {
	//  // 对边上面对象的id
	// 	"source": "1", // 起点
	// 	"target": "0" // 终点
	// },
	// let friendsArr = []
	result.map(item => {
		let symbolSize = null
		let category = null
		if (item.BE_GOOD_FRIENDS.length === 0) {
			symbolSize = 4
			category = 0
		} else if (item.BE_GOOD_FRIENDS.length >= 1 && item.BE_GOOD_FRIENDS.length <= 3) {
			symbolSize = 8
			category = 1
		} else if (item.BE_GOOD_FRIENDS.length >= 4 && item.BE_GOOD_FRIENDS.length <= 6) {
			symbolSize = 12
			category = 2
		} else if (item.BE_GOOD_FRIENDS.length >= 7 && item.BE_GOOD_FRIENDS.length <= 9) {
			symbolSize = 16
			category = 3
		} else if (item.BE_GOOD_FRIENDS.length >= 10 && item.BE_GOOD_FRIENDS.length <= 15) {
			symbolSize = 20
			category = 4
		} else {
			symbolSize = 24
			category = 5
		}
		datas.push({
			id: item.UID + '',
			name: item.REAL_NAME,
			uid: item.UID,
			symbolSize: symbolSize, // 点的大小：选择他的朋友个数乘以5
			category: category, // 图例：选择他的朋友个数
			value: item.BE_GOOD_FRIENDS.length // 有多少朋友选择了他
		})
		if (item.BE_GOOD_FRIENDS.length) { // 有朋友选择了他进行连线
			item.BE_GOOD_FRIENDS.map(value => {
				lines.push({
					source: value.UID,
					sourceName: value.REAL_NAME,
					target: item.UID + '',
					targetName: item.REAL_NAME
				})
			})
		}
	})
	return {
		datas,
		lines
	}
}
